import { Assessment } from '@/interfaces/assessment';
import { AssessmentResource, assessmentResource } from '@/resources/assessment.resource';
import { EntityModule } from './entity.module';

/**
 * Moduł ocen
 *
 * @export
 * @class AssessmentModule
 * @extends {EntityModule<Assessment, AssessmentResource>}
 */
export class AssessmentModule extends EntityModule<Assessment, AssessmentResource> {
  constructor() {
    super(assessmentResource);
  }
}

export default new AssessmentModule();
